import { EMAIL_SUBSCRIPTION_URL } from "../constants/constants";
const SubscriptionApiUrl = EMAIL_SUBSCRIPTION_URL;

export const submitUnsubscribe = (token) => {
  return fetch(`${SubscriptionApiUrl}/${token}`, { method: "DELETE" }).then(
    (response) => response.json()
  );
};
